export const CHANGE_DATE_BY_TYPE = 'CHANGE_CASHBACK_DATE_BY_TYPE';
export const FETCH_CASHBACK_LIST = 'FETCH_CASHBACK_LIST';
export const SET_CURRENT_PAGE = 'SET_CASHBACK_CURRENT_PAGE';
export const CHANGE_DATE_FILTER_TYPE = "CHANGE_FILTER_TYPE";

const setCurrentPage = (currentPage) => {
  return {
    type: SET_CURRENT_PAGE,
    payload: { currentPage },
  };
};

const changeDateByType = (dateType, date) => {
  return {
    type: CHANGE_DATE_BY_TYPE,
    payload: {
      dateType,
      date,
    },
  };
};

const changeDateFilterType = (dateFilterType) => {
  return {
    type: CHANGE_DATE_FILTER_TYPE,
    payload: {
      dateFilterType
    }
  }
}

const fetchCashbackByFilter = (config = {}) => {
  return async (dispatch, getState, { AccountCashbackApi }) => {
    dispatch(fetchCashbackListPending());
    try {
      const {
        AccountCashback: { limit, startDate, endDate, currentPage },
      } = getState();

      const initialConfig = { currentPage, limit, startDate, endDate };

      const { data: _data } = await AccountCashbackApi.getCashbackByFilter({
        ...initialConfig,
        ...config,
      });
      let data = _data?.paid ?? [];
      
      const isNextPageAvailable = data?.length > limit;
      if (isNextPageAvailable) data = data.slice(0, limit);

      dispatch(fetchCashbackListSuccess({ data, isNextPageAvailable }));
      return { data, isNextPageAvailable };
    } catch (error) {
      dispatch(fetchCashbackListFailure(error));
      throw error;
    }
  };
};

const fetchCashbackListSuccess = ({ data, isNextPageAvailable }) => {
  return {
    type: `${FETCH_CASHBACK_LIST}_SUCCESS`,
    payload: { data, isNextPageAvailable },
  };
};

const fetchCashbackListPending = () => {
  return {
    type: `${FETCH_CASHBACK_LIST}_PENDING`,
  };
};

const fetchCashbackListFailure = (error) => {
  return {
    type: `${FETCH_CASHBACK_LIST}_FAILURE`,
    payload: { error },
  };
};

export { changeDateByType, fetchCashbackByFilter, setCurrentPage, changeDateFilterType };
